import GameStepBase, {cancelGameFlow} from './game_step_base';

export default class LoginGameStep extends GameStepBase {
    static CLASS = 'LoginGameStep';

    run(gameOptions) {
        if(this.serviceFactory.oAuth2Service().isAuthorized()) {
            return Promise.resolve(gameOptions);
        }

        return this.serviceFactory.webLoginService().openLoginForm().then(() => {
            return gameOptions;
        }).catch(err => {
            if (!err) {
                return cancelGameFlow('USER CANCELED THE LOGIN');
            } else {
                throw err;
            }
        });
    }
}